// ** Redux, Thunk & Root Reducer Imports
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import rootReducer from '../reducers/rootReducer';
import {createStore, applyMiddleware, compose} from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import filters from '../reducers/filters';
import page from '../reducers/page';
import sort from '../reducers/sort';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['tabs', 'filters', 'sort', 'page'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ** init middleware
const middleware = [thunk, createDebounce()];

// ** Dev Tools
const composeEnhancers = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware));

const store = createStore(persistedReducer, {}, enhancer);

// const store = createStore(rootReducer, {}, enhancer);
const persistor = persistStore(store);

export { store, persistor };